import React from 'react';

// Superfície base. tone: default | navy | tint | muted
export const Card = React.forwardRef(function Card(
  { as: Tag = 'div', tone = 'default', interactive = false, padding = 'md', className = '', children, ...props }, ref,
) {
  const isButton = Tag === 'button';
  return (
    <Tag
      ref={ref}
      className={`ss-card ss-card--${tone} ss-card--pad-${padding} ${interactive ? 'ss-card--interactive' : ''} ${className}`}
      type={isButton ? 'button' : undefined}
      {...props}
    >
      {children}
    </Tag>
  );
});

// Número grande em Oswald com legenda, como os destaques do deck.
export function StatCard({ value, label, hint, icon: Icon, accent = false, onClick, className = '' }) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      className={`ss-stat ${accent ? 'ss-stat--accent' : ''} ${onClick ? 'ss-stat--interactive' : ''} ${className}`}
      onClick={onClick}
      type={onClick ? 'button' : undefined}
    >
      {Icon && (
        <span className="ss-stat__icon">
          <Icon size={18} strokeWidth={2.2} aria-hidden="true" />
        </span>
      )}
      <span className="ss-stat__value">{value}</span>
      <span className="ss-stat__label">{label}</span>
      {hint && <span className="ss-stat__hint">{hint}</span>}
    </Tag>
  );
}

// Quadrado azul-marinho com ícone verde-limão.
export function IconSquare({ icon: Icon, size = 44, tone = 'navy', color, className = '' }) {
  // Com cor customizada o ícone fica branco, para manter contraste em qualquer fundo.
  const style = color ? { background: color, color: '#fff' } : undefined;
  return (
    <span className={`ss-square ss-square--${tone} ${className}`} style={{ width: size, height: size, ...style }}>
      <Icon size={Math.round(size * 0.5)} strokeWidth={2} aria-hidden="true" />
    </span>
  );
}

// Ícone num círculo claro, usado ao lado de títulos.
export function IconBadge({ icon: Icon, size = 48, tone = 'lime', className = '' }) {
  return (
    <span className={`ss-badge-icon ss-badge-icon--${tone} ${className}`} style={{ width: size, height: size }}>
      <Icon size={Math.round(size * 0.5)} strokeWidth={2} aria-hidden="true" />
    </span>
  );
}

// Card de ação: quadrado com ícone, título e descrição.
export function ActionTile({ icon, title, description, onClick, tone = 'default', className = '' }) {
  return (
    <button type="button" className={`ss-tile ss-tile--${tone} ${className}`} onClick={onClick}>
      <IconSquare icon={icon} size={48} tone={tone === 'navy' ? 'lime' : 'navy'} />
      <span className="ss-tile__text">
        <span className="ss-tile__title">{title}</span>
        {description && <span className="ss-tile__desc">{description}</span>}
      </span>
    </button>
  );
}
